import React from "react";
import { UserContext } from "../context/UserContext";
import LoadingUser from "./LoadingUser";

export default function Callback(props: any) {
  const auth = React.useContext(UserContext);
  if (/access_token|id_token|error/.test(props.location.hash)) {
    const ssoMatches = props.location.hash.match(/sso_login=true/);
    auth.handleAuthentication(ssoMatches ? true : false);
  }
  return <LoadingUser />;
}
